<template>
  <section class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col s12 m4">
          <div class="links-logo">
            <div>
              <img src="@/assets/images/a141/Cambridge-logo-white.png" alt="" />
            </div>
          </div>
        </div>
        <div class="col s12 m8">
          <div class="social">
            <div class="pcg-footer-contact-table">
              <div class="icons">
                <a
                  href="https://www.facebook.com/A141Community"
                  target="_blank"
                  title="Follow us on Facebook"
                >
                  <img
                    src="@/assets/images/a141/footericons/icon-facebook.png"
                    alt=""
                  />
                </a>
                <a
                  href="https://twitter.com/CambsPboroCA"
                  target="_blank"
                  title="Follow us on Twitter"
                >
                  <img
                    src="@/assets/images/a141/footericons/icon-twitter.png"
                    alt=""
                  />
                </a>
                <a
                  href="https://www.instagram.com/CambsPboroCA/"
                  target="_blank"
                  title="News RSS"
                >
                  <img
                    src="@/assets/images/a141/footericons/icon-instagram.png"
                    alt=""
                  />
                </a>
              </div>
              <h4 class="pcg-footer-contact-link">
                If you have any questions please contact us on :<br />
                <br />
                <a
                  href="mailto:YourStIves@cambridgeshirepeterborough-ca.gov.uk"
                  target="blank"
                  >YourStIves@cambridgeshirepeterborough-ca.gov.uk</a
                >
                <br /><br />
                #YourStIves
              </h4>
              <div class="pcg-footer-copyright">
                © Copyright 2021 Cambridgeshire & Peterborough Combined
                Authority. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "site-footer",
};
</script>
